
/*
 * PAWS & PEARLS — THE MUSE
 * DISTANT ROSE BIRDS V1.2 — THREE FLOCKS
 *
 * Keeps F1, F3, F5.
 * Removes F2 and F4.
 * Adds larger roaming paths and little bobs.
 *
 * Existing balloon, creatures and sounds
 * remain untouched.
 */

(function () {
  'use strict';

  var VERSION = '1.2-three-flocks-lively';
  var SKY_ID = 'pp-muse-secret-sky';
  var CONFIG_ID = 'pp-muse-rose-flock-assets';
  var LAYER_ID = 'pp-muse-distant-rose-birds-v1';
  var STYLE_ID = LAYER_ID + '-style';
  var NS = 'ppMuseDistantRoseBirds';

  var instance = null;
  var resizeFrame = 0;

  // ALTERNATING FLOCKS: F1, F3, F5.
  // Spread across the upper sky.
  // More movement, without frantic motion.

  var flocks = Object.freeze([
    {
      id:'F1', asset:'a',
      x:10, y:7, width:0.098,
      duration:28, delay:-3,
      dx1:32, dy1:-14,
      dx2:-25, dy2:14,
      dx3:16, dy3:19,
      tilt1:-1.7, tilt2:1.1, tilt3:-0.6,
      bobDuration:5.2, bobDelay:-1.1
    },
    {
      id:'F3', asset:'c',
      x:29, y:10, width:0.096,
      duration:30, delay:-15,
      dx1:29, dy1:13,
      dx2:-23, dy2:-16,
      dx3:14, dy3:17,
      tilt1:-1.5, tilt2:1.2, tilt3:-0.6,
      bobDuration:4.6, bobDelay:-3.2
    },
    {
      id:'F5', asset:'e',
      x:48, y:14, width:0.108,
      duration:29, delay:-12,
      dx1:27, dy1:-12,
      dx2:-21, dy2:14,
      dx3:15, dy3:18,
      tilt1:-1.3, tilt2:1.0, tilt3:-0.6,
      bobDuration:5.8, bobDelay:-2.4
    }
  ]);

  function report(message) {
    if (window.console && console.info) {
      console.info(
        '[P&P distant rose birds] ' + message
      );
    }
  }

  function assetUrls() {
    var node = document.getElementById(CONFIG_ID);
    if (!node) return null;

    var d = node.dataset || {};

    // Existing Shopify asset block.
    // Only A, C and E are needed now.
    var urls = {
      a: d.a,
      c: d.c,
      e: d.e
    };

    for (var key in urls) {
      var url = urls[key];

      if (
        typeof url !== 'string' ||
        !(/^(https?:\/\/|\/)/.test(url))
      ) return null;
    }

    return urls;
  }

  function cssText() {
    return [
      'html.pp-muse-secret-sky-page #'+
      SKY_ID+' #'+LAYER_ID+'{'+
      'position:absolute!important;'+
      'inset:0!important;z-index:2!important;'+
      'overflow:hidden!important;'+
      'pointer-events:none!important;'+
      'user-select:none!important;}',

      'html.pp-muse-secret-sky-page #'+
      LAYER_ID+' .pp-distant-rose-flock{'+
      'position:absolute!important;'+
      'display:block!important;'+
      'pointer-events:none!important;'+
      'user-select:none!important;'+
      'transform:translate(-50%,-50%);'+
      'will-change:transform;'+
      'animation:pp-rose-flock-loiter '+ 
      'var(--pp-duration) ease-in-out '+ 
      'var(--pp-delay) infinite both;}',

      'html.pp-muse-secret-sky-page #'+
      LAYER_ID+' .pp-distant-rose-flock img{'+
      'display:block!important;'+
      'width:100%!important;'+
      'height:auto!important;'+
      'max-width:none!important;'+
      'opacity:1!important;'+
      'object-fit:contain!important;'+
      'pointer-events:none!important;'+
      'user-select:none!important;'+
      '-webkit-user-drag:none;'+
      'filter:none!important;'+
      'animation:pp-rose-flock-microbob '+ 
      'var(--pp-bob-duration) ease-in-out '+ 
      'var(--pp-bob-delay) infinite alternate both;}',

      '@keyframes pp-rose-flock-loiter{',
      '0%,100%{transform:translate(-50%,-50%) '+
      'translate3d(0,0,0) rotate(0deg);}',
      '24%{transform:translate(-50%,-50%) '+
      'translate3d(var(--dx1),var(--dy1),0) '+
      'rotate(var(--tilt1));}',
      '52%{transform:translate(-50%,-50%) '+
      'translate3d(var(--dx2),var(--dy2),0) '+
      'rotate(var(--tilt2));}',
      '76%{transform:translate(-50%,-50%) '+
      'translate3d(var(--dx3),var(--dy3),0) '+
      'rotate(var(--tilt3));}',
      '}',

      // Small independent bobbing motion.
      // Each flock has its own tempo.

      '@keyframes pp-rose-flock-microbob{',
      '0%{transform:translate3d(0,-4px,0) '+
      'rotate(-0.7deg);}',
      '100%{transform:translate3d(0,6px,0) '+
      'rotate(0.7deg);}',
      '}',

      // On mobile, retain all THREE flocks,
      // staggered across the upper sky.

      '@media(max-width:767px){',
      'html.pp-muse-secret-sky-page #'+
      LAYER_ID+
      ' .pp-distant-rose-flock[data-flock-id="F1"]'+
      '{left:16%!important;top:10%!important;}',

      'html.pp-muse-secret-sky-page #'+
      LAYER_ID+
      ' .pp-distant-rose-flock[data-flock-id="F3"]'+
      '{left:40%!important;top:18%!important;}',

      'html.pp-muse-secret-sky-page #'+
      LAYER_ID+
      ' .pp-distant-rose-flock[data-flock-id="F5"]'+
      '{left:64%!important;top:12%!important;}',
      '}',

      '@media(prefers-reduced-motion:reduce){',
      '#'+LAYER_ID+' .pp-distant-rose-flock,'+
      '#'+LAYER_ID+' .pp-distant-rose-flock img'+
      '{animation:none!important;}',
      '}'
    ].join('');
  }

  function clamp(min, val, max) {
    return Math.min(max, Math.max(min, val));
  }

  function sizeFlocks() {
    if (
      !instance ||
      !instance.wrapper.isConnected
    ) return;

    var width =
      instance.wrapper.clientWidth ||
      window.innerWidth ||
      1440;

    for (
      var i = 0;
      i < instance.flocks.length;
      i++
    ) {
      var item = instance.flocks[i];

      var px = clamp(
        78,
        width * item.spec.width,
        196
      );

      item.node.style.width =
        px.toFixed(1) + 'px';
    }
  }

  function resize() {
    if (resizeFrame) return;

    resizeFrame = window.requestAnimationFrame(
      function () {
        resizeFrame = 0;
        sizeFlocks();
      }
    );
  }

  function remove() {
    if (resizeFrame) {
      window.cancelAnimationFrame(resizeFrame);
    }

    resizeFrame = 0;

    if (instance && instance.layer) {
      instance.layer.remove();
    }

    instance = null;
  }

  function initialize() {
    if (
      !document.documentElement.classList.contains(
        'pp-muse-secret-sky-page'
      )
    ) return;

    var sky = document.getElementById(SKY_ID);
    var wrapper = document.querySelector(
      '.page-wrapper'
    );

    if (
      !sky ||
      !wrapper ||
      !wrapper.contains(sky)
    ) return;

    if (
      instance &&
      instance.sky === sky &&
      instance.layer.isConnected
    ) {
      sizeFlocks();
      return;
    }

    var urls = assetUrls();

    if (!urls) {
      report(
        'Bird assets unavailable; sky unchanged.'
      );
      return;
    }

    remove();

    var style = document.getElementById(
      STYLE_ID
    );

    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      document.head.appendChild(style);
    }

    style.textContent = cssText();

    var layer = document.createElement('div');

    layer.id = LAYER_ID;
    layer.setAttribute('aria-hidden', 'true');
    layer.setAttribute(
      'data-depth',
      'behind-creatures-ahead-of-background-balloons'
    );

    var nodes = [];

    for (
      var i = 0;
      i < flocks.length;
      i++
    ) {
      var spec = flocks[i];

      var node = document.createElement('div');
      node.className = 'pp-distant-rose-flock';

      node.setAttribute(
        'data-flock-id',
        spec.id
      );

      node.style.left = spec.x + '%';
      node.style.top = spec.y + '%';
      node.style.opacity = '1';

      node.style.setProperty(
        '--pp-duration',
        spec.duration + 's'
      );

      node.style.setProperty(
        '--pp-delay',
        spec.delay + 's'
      );

      ['dx1','dy1','dx2','dy2','dx3','dy3']
        .forEach(function (key) {
          node.style.setProperty(
            '--' + key,
            spec[key] + 'px'
          );
        });

      ['tilt1','tilt2','tilt3']
        .forEach(function (key) {
          node.style.setProperty(
            '--' + key,
            spec[key] + 'deg'
          );
        });

      node.style.setProperty(
        '--pp-bob-duration',
        spec.bobDuration + 's'
      );

      node.style.setProperty(
        '--pp-bob-delay',
        spec.bobDelay + 's'
      );

      var img = document.createElement('img');
      img.src = urls[spec.asset];
      img.alt = '';
      img.decoding = 'async';
      img.loading = 'eager';
      img.draggable = false;

      img.setAttribute(
        'aria-hidden',
        'true'
      );

      node.appendChild(img);
      layer.appendChild(node);

      nodes.push({
        node: node,
        spec: spec
      });
    }

    sky.appendChild(layer);

    instance = {
      layer: layer,
      sky: sky,
      wrapper: wrapper,
      flocks: nodes
    };

    sizeFlocks();

    report(
      'Three flocks F1/F3/F5, spaced apart, with livelier movement.'
    );
  }

  window[NS] = {
    version: VERSION,

    getStatus: function () {
      return {
        present: !!(
          instance &&
          instance.layer &&
          instance.layer.isConnected
        ),

        flockCount: instance
          ? instance.flocks.length
          : 0,

        mobileMode: !!(
          window.matchMedia &&
          window.matchMedia(
            '(max-width:767px)'
          ).matches
        ),

        zDepth:
          'in front of distant balloons, behind foreground creatures',

        changesMuseFlight: false
      };
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      { once: true }
    );
  } else {
    initialize();
  }

  document.addEventListener(
    'shopify:section:load',
    initialize
  );

  document.addEventListener(
    'shopify:section:unload',
    function (event) {
      if (
        instance &&
        event.target &&
        (
          event.target.contains(instance.sky) ||
          event.target === instance.sky
        )
      ) {
        remove();
      }
    }
  );

  window.addEventListener(
    'resize',
    resize,
    { passive: true }
  );

  window.addEventListener(
    'pageshow',
    initialize
  );

})();
